"use client";
import React from 'react';

function useUnmountEffect(fn, deps = []) {
    return React.useEffect(() => () => fn(), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
}

export { useUnmountEffect };
//# sourceMappingURL=useUnmountEffect.js.map
